// Free tier: the line under "Free" on the Request Price card (founder picks
// 2026-09-29). It names the talent's next step only once the bank is done;
// the tap always opens the money gate (lib/connectBank), which shows the rest.
//
//   no bank connected            → no line, just "Free"
//   bank done, nothing to review → "Add your Instagram to get verified"
//   bank done, in review         → "In review"
//   declined                     → no line (the sheet carries the way forward)
import type { User } from "../types/User";
import { whichGate } from "../lib/connectBank";
import { t } from "../i18n";

export function freeTierLine(profile: Pick<User, "approvalStatus" | "isStripeOnboarded" | "isAdminCreated" | "chosenDeferredStripe" | "payout">): string {
  if (profile.approvalStatus === "declined" || whichGate(profile) === "bank") return "";
  return profile.approvalStatus === "needs_instagram" ? t("freeTierLine.addYourInstagramTo") : t("freeTierLine.inReview");
}
